"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
/**
 * Business keys for a profile query, as received through the API request
 */
class ProfileQuery extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'business_partner_id' }),
    (0, base_models_1.Docs)({ example: 'partner_id', description: 'ID of business partner' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "businessPartnerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'krux_id' }),
    (0, base_models_1.Docs)({ example: 'LnhtnxtF', description: 'Krux ID' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "kruxId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'address_key' }),
    (0, base_models_1.Docs)({ example: '1234AB_56_C', description: 'Address' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "addressKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'communication_address_key' }),
    (0, base_models_1.Docs)({ example: '6543CB_21_A', description: 'Address for communication' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "communicationAddressKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'delivery_address_key' }),
    (0, base_models_1.Docs)({ example: '6543CB_21_A', description: 'Address for delivery' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "deliveryAddressKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'ean_g_code' }),
    (0, base_models_1.Docs)({ example: '5012345678900G', description: 'EAN G Code' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "eanGcode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'ean_e_code' }),
    (0, base_models_1.Docs)({ example: '5012345678900E', description: 'EAN E Code' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "eanEcode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'kvk_number' }),
    (0, base_models_1.Docs)({ example: '12345678', description: 'KVK Number' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "kvkNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'sizo_key' }),
    (0, base_models_1.Docs)({ example: 'S1771486', description: 'Sizo Key' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "sizoKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: 'customer@essent.nl', description: 'E-Mail Address' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "email", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: '01234567890', description: 'Primary phone number' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "phone", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'phone_mobile' }),
    (0, base_models_1.Docs)({ example: '06123456789', description: 'Mobile phone number' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "phoneMobile", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'phone_work' }),
    (0, base_models_1.Docs)({ example: '09876543210', description: 'Work phone number' }),
    tslib_1.__metadata("design:type", String)
], ProfileQuery.prototype, "phoneWork", void 0);
exports.default = ProfileQuery;
